import { useState } from "react";
import styles from "~/styles/burn-rate.module.css";

interface WaterfallItem {
  label: string;
  value: number;
  color: string;
}

interface WaterfallStripProps {
  items: WaterfallItem[];
  sym: string;
}

export function WaterfallStrip({ items, sym }: WaterfallStripProps) {
  const [hovered, setHovered] = useState<number | null>(null);
  const validItems = items.filter((i) => i.value > 0);
  const total = validItems.reduce((s, i) => s + i.value, 0) || 1;

  return (
    <div className={styles.chartCard}>
      <p className={styles.chartTitle}>Desglose</p>
      <div className={styles.waterfallTrack}>
        {validItems.map((item, i) => {
          const w = (item.value / total) * 100;
          return (
            <div
              key={i}
              className={styles.waterfallSegment}
              style={{
                width: `${w}%`,
                background: item.color,
                opacity: hovered === null || hovered === i ? 1 : 0.35,
              }}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              onTouchStart={() => setHovered(i)}
            >
              {w > 12 && (
                <span className={styles.waterfallLabel}>{item.label}</span>
              )}
            </div>
          );
        })}
      </div>
      <div className={styles.waterfallLegend}>
        {validItems.map((item, i) => (
          <button
            key={i}
            className={`${styles.waterfallLegendItem} ${hovered === i ? styles.waterfallLegendItemActive : ""}`}
            onMouseEnter={() => setHovered(i)}
            onMouseLeave={() => setHovered(null)}
            onTouchStart={() => setHovered(i)}
          >
            <span className={styles.waterfallDot} style={{ background: item.color }} />
            <span className={styles.waterfallLegendLabel}>{item.label}</span>
            <span className={styles.waterfallLegendValue}>{sym}{item.value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
